var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('Header'),_c('HelloWorld'),_c('div',{staticClass:"projects max-site-width"},_vm._l((_vm.projects),function(project,index){return _c('Project',{key:index,attrs:{"project":project}})}),1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }